"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormattedGraphqlError = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _FormattedAxiosError = require("./FormattedAxiosError");
var _trimText = require("./trimText");
/**
 * This formats FormattedAxiosError into more readable object for logging only
 */
class FormattedGraphqlError extends _FormattedAxiosError.FormattedAxiosError {
  constructor(error) {
    super(error);
    (0, _defineProperty2.default)(this, "graphqlVariables", void 0);
    (0, _defineProperty2.default)(this, "graphqlQuery", null);
    this.name = 'FormattedGraphqlError';
    this.graphqlVariables = error.graphqlVariables;
    if (error.graphqlQuery != null) {
      if (process.env.NODE_ENV === 'production') {
        // Make sure that the query is trimmed so we won't overfill Application Insights
        this.graphqlQuery = (0, _trimText.trimText)(error.graphqlQuery);
      } else {
        this.graphqlQuery = error.graphqlQuery;
      }
    }
  }
}
exports.FormattedGraphqlError = FormattedGraphqlError;
//# sourceMappingURL=FormattedGraphqlError.js.map